/**
 * topicSeedImages — the illustration shipped with the app for every topic.
 *
 * One unique file per topic address (slug). This is the single source of truth
 * for a topic's picture: article pictures are never promoted into it, so the
 * same picture can never appear on two topics.
 */

import img1031Exchange from '@/assets/topic-seeds/1031-exchange.jpg.asset.json';
import imgAfrmmMarinhaMercante from '@/assets/topic-seeds/afrmm-marinha-mercante.jpg.asset.json';
import imgAliquotaDeReferencia from '@/assets/topic-seeds/aliquota-de-referencia.jpg.asset.json';
import imgAntecipacaoDeComeCotas from '@/assets/topic-seeds/antecipacao-de-come-cotas.jpg.asset.json';
import imgAntiMoneyLaunderingAml from '@/assets/topic-seeds/anti-money-laundering-aml.jpg.asset.json';
import imgArtificialIntelligenceInLaw from '@/assets/topic-seeds/artificial-intelligence-in-law.jpg.asset.json';
import imgAuditorIndependence from '@/assets/topic-seeds/auditor-independence.jpg.asset.json';
import imgBehavioralTaxation from '@/assets/topic-seeds/behavioral-taxation.jpg.asset.json';
import imgBeneficialOwnership from '@/assets/topic-seeds/beneficial-ownership.jpg.asset.json';
import imgBeps from '@/assets/topic-seeds/beps.jpg.asset.json';
import imgCapacidadeContributiva from '@/assets/topic-seeds/capacidade-contributiva.jpg.asset.json';
import imgCapitalGainsTax from '@/assets/topic-seeds/capital-gains-tax.jpg.asset.json';
import imgCarbonCreditsTaxation from '@/assets/topic-seeds/carbon-credits-taxation.jpg.asset.json';
import imgCarneLeaoWeb from '@/assets/topic-seeds/carne-leao-web.jpg.asset.json';
import imgCashbackTributario from '@/assets/topic-seeds/cashback-tributario.jpg.asset.json';
import imgCbs from '@/assets/topic-seeds/cbs.jpg.asset.json';
import imgCestaBasicaNacional from '@/assets/topic-seeds/cesta-basica-nacional.jpg.asset.json';
import imgCfcRules from '@/assets/topic-seeds/cfc-rules.jpg.asset.json';
import imgCideCombustiveis from '@/assets/topic-seeds/cide-combustiveis.jpg.asset.json';
import imgCideRemessas from '@/assets/topic-seeds/cide-remessas.jpg.asset.json';
import imgCitizenshipByInvestment from '@/assets/topic-seeds/citizenship-by-investment.jpg.asset.json';
import imgCivilProcedure from '@/assets/topic-seeds/civil-procedure.jpg.asset.json';
import imgCofins from '@/assets/topic-seeds/cofins.jpg.asset.json';
import imgComiteGestorDoIbs from '@/assets/topic-seeds/comite-gestor-do-ibs.jpg.asset.json';
import imgConfaz from '@/assets/topic-seeds/confaz.jpg.asset.json';
import imgConstitutionalJurisdiction from '@/assets/topic-seeds/constitutional-jurisdiction.jpg.asset.json';
import imgConstitutionalTaxLaw from '@/assets/topic-seeds/constitutional-tax-law.jpg.asset.json';
import imgContribuicaoDeMelhoria from '@/assets/topic-seeds/contribuicao-de-melhoria.jpg.asset.json';
import imgContribuicaoPrevidenciariaPatronal from '@/assets/topic-seeds/contribuicao-previdenciaria-patronal.jpg.asset.json';
import imgContribuicaoSindicalAssistencial from '@/assets/topic-seeds/contribuicao-sindical-assistencial.jpg.asset.json';
import imgCorporateGovernance from '@/assets/topic-seeds/corporate-governance.jpg.asset.json';
import imgCorporateReorganization from '@/assets/topic-seeds/corporate-reorganization.jpg.asset.json';
import imgCorporateTax from '@/assets/topic-seeds/corporate-tax.jpg.asset.json';
import imgCosipIluminacaoPublica from '@/assets/topic-seeds/cosip-iluminacao-publica.jpg.asset.json';
import imgCreditoFinanceiro from '@/assets/topic-seeds/credito-financeiro.jpg.asset.json';
import imgCriminalProcedure from '@/assets/topic-seeds/criminal-procedure.jpg.asset.json';
import imgCriticalTaxTheory from '@/assets/topic-seeds/critical-tax-theory.jpg.asset.json';
import imgCrs from '@/assets/topic-seeds/crs.jpg.asset.json';
import imgCryptocurrencyTax from '@/assets/topic-seeds/cryptocurrency-tax.jpg.asset.json';
import imgCsll from '@/assets/topic-seeds/csll.jpg.asset.json';
import imgDebtEnforcement from '@/assets/topic-seeds/debt-enforcement.jpg.asset.json';
import imgDeclaracaoPrePreenchida from '@/assets/topic-seeds/declaracao-pre-preenchida.jpg.asset.json';
import imgDeducoesDeEducacao from '@/assets/topic-seeds/deducoes-de-educacao.jpg.asset.json';
import imgDeducoesDeSaude from '@/assets/topic-seeds/deducoes-de-saude.jpg.asset.json';
import imgDepositContractLaw from '@/assets/topic-seeds/deposit-contract-law.jpg.asset.json';
import imgDifalInterestadual from '@/assets/topic-seeds/difal-interestadual.jpg.asset.json';
import imgDigitalServicesTax from '@/assets/topic-seeds/digital-services-tax.jpg.asset.json';
import imgDigitalizationOfLegalProcesses from '@/assets/topic-seeds/digitalization-of-legal-processes.jpg.asset.json';
import imgDrawbackAduaneiro from '@/assets/topic-seeds/drawback-aduaneiro.jpg.asset.json';
import imgEconomicStability from '@/assets/topic-seeds/economic-stability.jpg.asset.json';
import imgEmprestimoCompulsorio from '@/assets/topic-seeds/emprestimo-compulsorio.jpg.asset.json';
import imgEnergyTariffs from '@/assets/topic-seeds/energy-tariffs.jpg.asset.json';
import imgEstatePlanning from '@/assets/topic-seeds/estate-planning.jpg.asset.json';
import imgEstateTax from '@/assets/topic-seeds/estate-tax.jpg.asset.json';
import imgExTarifario from '@/assets/topic-seeds/ex-tarifario.jpg.asset.json';
import imgExclusaoDoCreditoTributario from '@/assets/topic-seeds/exclusao-do-credito-tributario.jpg.asset.json';
import imgExitTax from '@/assets/topic-seeds/exit-tax.jpg.asset.json';
import imgExtincaoDoCreditoTributario from '@/assets/topic-seeds/extincao-do-credito-tributario.jpg.asset.json';
import imgFatca from '@/assets/topic-seeds/fatca.jpg.asset.json';
import imgFbar from '@/assets/topic-seeds/fbar.jpg.asset.json';
import imgFdii from '@/assets/topic-seeds/fdii.jpg.asset.json';
import imgFgtsDigital from '@/assets/topic-seeds/fgts-digital.jpg.asset.json';
import imgFinancialRegulatoryCompliance from '@/assets/topic-seeds/financial-regulatory-compliance.jpg.asset.json';
import imgFinancialSystemRegulation from '@/assets/topic-seeds/financial-system-regulation.jpg.asset.json';
import imgFinancialTransactionTax from '@/assets/topic-seeds/financial-transaction-tax.jpg.asset.json';
import imgFiscalPolicy from '@/assets/topic-seeds/fiscal-policy.jpg.asset.json';
import imgFiscalTransparency from '@/assets/topic-seeds/fiscal-transparency.jpg.asset.json';
import imgForeignTaxCredit from '@/assets/topic-seeds/foreign-tax-credit.jpg.asset.json';
import imgForm3520 from '@/assets/topic-seeds/form-3520.jpg.asset.json';
import imgForm5471 from '@/assets/topic-seeds/form-5471.jpg.asset.json';
import imgForm8865 from '@/assets/topic-seeds/form-8865.jpg.asset.json';
import imgFoundation from '@/assets/topic-seeds/foundation.jpg.asset.json';
import imgFundoDeDesenvolvimentoRegional from '@/assets/topic-seeds/fundo-de-desenvolvimento-regional.jpg.asset.json';
import imgFundosExclusivos from '@/assets/topic-seeds/fundos-exclusivos.jpg.asset.json';
import imgGanhoDeCapital from '@/assets/topic-seeds/ganho-de-capital.jpg.asset.json';
import imgGiftTax from '@/assets/topic-seeds/gift-tax.jpg.asset.json';
import imgGilti from '@/assets/topic-seeds/gilti.jpg.asset.json';
import imgGovernmentSpendingPrograms from '@/assets/topic-seeds/government-spending-programs.jpg.asset.json';
import imgHoldingCompany from '@/assets/topic-seeds/holding-company.jpg.asset.json';
import imgIbs from '@/assets/topic-seeds/ibs.jpg.asset.json';
import imgIcms from '@/assets/topic-seeds/icms.jpg.asset.json';
import imgIeImpostoDeExportacao from '@/assets/topic-seeds/ie-imposto-de-exportacao.jpg.asset.json';
import imgIiImpostoDeImportacao from '@/assets/topic-seeds/ii-imposto-de-importacao.jpg.asset.json';
import imgImpostoDoPecado from '@/assets/topic-seeds/imposto-do-pecado.jpg.asset.json';
import imgImpostoSeletivo from '@/assets/topic-seeds/imposto-seletivo.jpg.asset.json';
import imgInDubioProReoFiscal from '@/assets/topic-seeds/in-dubio-pro-reo-fiscal.jpg.asset.json';
import imgIncomeTax from '@/assets/topic-seeds/income-tax.jpg.asset.json';
import imgInterdisciplinaryTaxLaw from '@/assets/topic-seeds/interdisciplinary-tax-law.jpg.asset.json';
import imgInternationalAccountingStandards from '@/assets/topic-seeds/international-accounting-standards.jpg.asset.json';
import imgInternationalTaxCompliance from '@/assets/topic-seeds/international-tax-compliance.jpg.asset.json';
import imgInternationalTaxPolicy from '@/assets/topic-seeds/international-tax-policy.jpg.asset.json';
import imgInterpretacaoBenigna from '@/assets/topic-seeds/interpretacao-benigna.jpg.asset.json';
import imgIofCambioECredito from '@/assets/topic-seeds/iof-cambio-e-credito.jpg.asset.json';
import imgIpi from '@/assets/topic-seeds/ipi.jpg.asset.json';
import imgIptu from '@/assets/topic-seeds/iptu.jpg.asset.json';
import imgIptuProgressivo from '@/assets/topic-seeds/iptu-progressivo.jpg.asset.json';
import imgIpvaAeronavesEEmbarcacoes from '@/assets/topic-seeds/ipva-aeronaves-e-embarcacoes.jpg.asset.json';
import imgIrpf from '@/assets/topic-seeds/irpf.jpg.asset.json';
import imgIrpj from '@/assets/topic-seeds/irpj.jpg.asset.json';
import imgIsencaoPorDoencaGrave from '@/assets/topic-seeds/isencao-por-doenca-grave.jpg.asset.json';
import imgIss from '@/assets/topic-seeds/iss.jpg.asset.json';
import imgItbi from '@/assets/topic-seeds/itbi.jpg.asset.json';
import imgItbiMomentoDeIncidencia from '@/assets/topic-seeds/itbi-momento-de-incidencia.jpg.asset.json';
import imgItcmd from '@/assets/topic-seeds/itcmd.jpg.asset.json';
import imgItcmdProgressivo from '@/assets/topic-seeds/itcmd-progressivo.jpg.asset.json';
import imgItrPropriedadeRural from '@/assets/topic-seeds/itr-propriedade-rural.jpg.asset.json';
import imgIvaDual from '@/assets/topic-seeds/iva-dual.jpg.asset.json';
import imgJudicialAppeals from '@/assets/topic-seeds/judicial-appeals.jpg.asset.json';
import imgJudicialIntegrity from '@/assets/topic-seeds/judicial-integrity.jpg.asset.json';
import imgJudicialPenalties from '@/assets/topic-seeds/judicial-penalties.jpg.asset.json';
import imgJudicialReview from '@/assets/topic-seeds/judicial-review.jpg.asset.json';
import imgJurosSobreCapitalProprio from '@/assets/topic-seeds/juros-sobre-capital-proprio.jpg.asset.json';
import imgLancamentoDeOficio from '@/assets/topic-seeds/lancamento-de-oficio.jpg.asset.json';
import imgLancamentoPorHomologacao from '@/assets/topic-seeds/lancamento-por-homologacao.jpg.asset.json';
import imgLaudemioEForo from '@/assets/topic-seeds/laudemio-e-foro.jpg.asset.json';
import imgLegalProcedureReform from '@/assets/topic-seeds/legal-procedure-reform.jpg.asset.json';
import imgLegislativeProcess from '@/assets/topic-seeds/legislative-process.jpg.asset.json';
import imgLlcTaxation from '@/assets/topic-seeds/llc-taxation.jpg.asset.json';
import imgLucroArbitrado from '@/assets/topic-seeds/lucro-arbitrado.jpg.asset.json';
import imgLucroPresumido from '@/assets/topic-seeds/lucro-presumido.jpg.asset.json';
import imgLucroReal from '@/assets/topic-seeds/lucro-real.jpg.asset.json';
import imgMalhaFinaDigital from '@/assets/topic-seeds/malha-fina-digital.jpg.asset.json';
import imgMonofasiaTributaria from '@/assets/topic-seeds/monofasia-tributaria.jpg.asset.json';
import imgNaoCumulatividadePlena from '@/assets/topic-seeds/nao-cumulatividade-plena.jpg.asset.json';
import imgNfe from '@/assets/topic-seeds/nfe.jpg.asset.json';
import imgOpportunityZone from '@/assets/topic-seeds/opportunity-zone.jpg.asset.json';
import imgOutsourcingOfProfessionalServices from '@/assets/topic-seeds/outsourcing-of-professional-services.jpg.asset.json';
import imgPartnership from '@/assets/topic-seeds/partnership.jpg.asset.json';
import imgPayrollTax from '@/assets/topic-seeds/payroll-tax.jpg.asset.json';
import imgPermanentEstablishment from '@/assets/topic-seeds/permanent-establishment.jpg.asset.json';
import imgPfic from '@/assets/topic-seeds/pfic.jpg.asset.json';
import imgPillarTwo from '@/assets/topic-seeds/pillar-two.jpg.asset.json';
import imgPis from '@/assets/topic-seeds/pis.jpg.asset.json';
import imgPraticabilidadeTributaria from '@/assets/topic-seeds/praticabilidade-tributaria.jpg.asset.json';
import imgPricingOfTaxServices from '@/assets/topic-seeds/pricing-of-tax-services.jpg.asset.json';
import imgPrincipioDaAnterioridade from '@/assets/topic-seeds/principio-da-anterioridade.jpg.asset.json';
import imgPrincipioDaIrretroatividade from '@/assets/topic-seeds/principio-da-irretroatividade.jpg.asset.json';
import imgPrincipioDaIsonomia from '@/assets/topic-seeds/principio-da-isonomia.jpg.asset.json';
import imgPrincipioDaLegalidade from '@/assets/topic-seeds/principio-da-legalidade.jpg.asset.json';
import imgPrincipioDaSeletividade from '@/assets/topic-seeds/principio-da-seletividade.jpg.asset.json';
import imgPrincipioDoDestino from '@/assets/topic-seeds/principio-do-destino.jpg.asset.json';
import imgPrincipioDoNaoConfisco from '@/assets/topic-seeds/principio-do-nao-confisco.jpg.asset.json';
import imgPrivateClient from '@/assets/topic-seeds/private-client.jpg.asset.json';
import imgProceduralTaxLaw from '@/assets/topic-seeds/procedural-tax-law.jpg.asset.json';
import imgProfessionalEthicsInTaxation from '@/assets/topic-seeds/professional-ethics-in-taxation.jpg.asset.json';
import imgProfessionalRegulation from '@/assets/topic-seeds/professional-regulation.jpg.asset.json';
import imgProgressiveTaxation from '@/assets/topic-seeds/progressive-taxation.jpg.asset.json';
import imgPropertyTax from '@/assets/topic-seeds/property-tax.jpg.asset.json';
import imgPublicFinanceManagement from '@/assets/topic-seeds/public-finance-management.jpg.asset.json';
import imgPublicServiceAdministration from '@/assets/topic-seeds/public-service-administration.jpg.asset.json';
import imgPublicServiceFees from '@/assets/topic-seeds/public-service-fees.jpg.asset.json';
import imgRatRiscoAmbientalTrabalho from '@/assets/topic-seeds/rat-risco-ambiental-trabalho.jpg.asset.json';
import imgRdTaxCredits from '@/assets/topic-seeds/rd-tax-credits.jpg.asset.json';
import imgReceitaFederal from '@/assets/topic-seeds/receita-federal.jpg.asset.json';
import imgReformaTributaria from '@/assets/topic-seeds/reforma-tributaria.jpg.asset.json';
import imgRegimesDiferenciados from '@/assets/topic-seeds/regimes-diferenciados.jpg.asset.json';
import imgRemessaConforme from '@/assets/topic-seeds/remessa-conforme.jpg.asset.json';
import imgResidenciaFiscal from '@/assets/topic-seeds/residencia-fiscal.jpg.asset.json';
import imgSCorporation from '@/assets/topic-seeds/s-corporation.jpg.asset.json';
import imgSalarioEducacao from '@/assets/topic-seeds/salario-educacao.jpg.asset.json';
import imgSection962 from '@/assets/topic-seeds/section-962.jpg.asset.json';
import imgSegurancaJuridica from '@/assets/topic-seeds/seguranca-juridica.jpg.asset.json';
import imgSimplesNacional from '@/assets/topic-seeds/simples-nacional.jpg.asset.json';
import imgSiscomex from '@/assets/topic-seeds/siscomex.jpg.asset.json';
import imgSistemaS from '@/assets/topic-seeds/sistema-s.jpg.asset.json';
import imgSocialSecurityBenefits from '@/assets/topic-seeds/social-security-benefits.jpg.asset.json';
import imgSped from '@/assets/topic-seeds/sped.jpg.asset.json';
import imgSplitPayment from '@/assets/topic-seeds/split-payment.jpg.asset.json';
import imgStateTax from '@/assets/topic-seeds/state-tax.jpg.asset.json';
import imgStatuteOfLimitationsPrescription from '@/assets/topic-seeds/statute-of-limitations-prescription.jpg.asset.json';
import imgSubpartF from '@/assets/topic-seeds/subpart-f.jpg.asset.json';
import imgSubstituicaoTributaria from '@/assets/topic-seeds/substituicao-tributaria.jpg.asset.json';
import imgSuspensaoDaExigibilidade from '@/assets/topic-seeds/suspensao-da-exigibilidade.jpg.asset.json';
import imgTaxAdministrativeProcedures from '@/assets/topic-seeds/tax-administrative-procedures.jpg.asset.json';
import imgTaxAppeals from '@/assets/topic-seeds/tax-appeals.jpg.asset.json';
import imgTaxAudit from '@/assets/topic-seeds/tax-audit.jpg.asset.json';
import imgTaxCareerDevelopment from '@/assets/topic-seeds/tax-career-development.jpg.asset.json';
import imgTaxClassification from '@/assets/topic-seeds/tax-classification.jpg.asset.json';
import imgTaxDebtResolution from '@/assets/topic-seeds/tax-debt-resolution.jpg.asset.json';
import imgTaxEducation from '@/assets/topic-seeds/tax-education.jpg.asset.json';
import imgTaxImmunity from '@/assets/topic-seeds/tax-immunity.jpg.asset.json';
import imgTaxIncentives from '@/assets/topic-seeds/tax-incentives.jpg.asset.json';
import imgTaxLawFundamentals from '@/assets/topic-seeds/tax-law-fundamentals.jpg.asset.json';
import imgTaxLitigation from '@/assets/topic-seeds/tax-litigation.jpg.asset.json';
import imgTaxOptimization from '@/assets/topic-seeds/tax-optimization.jpg.asset.json';
import imgTaxPolicyChallenges from '@/assets/topic-seeds/tax-policy-challenges.jpg.asset.json';
import imgTaxResidency from '@/assets/topic-seeds/tax-residency.jpg.asset.json';
import imgTaxSystemComplexity from '@/assets/topic-seeds/tax-system-complexity.jpg.asset.json';
import imgTaxTreaties from '@/assets/topic-seeds/tax-treaties.jpg.asset.json';
import imgTaxValuation from '@/assets/topic-seeds/tax-valuation.jpg.asset.json';
import imgTaxaDeIncendio from '@/assets/topic-seeds/taxa-de-incendio.jpg.asset.json';
import imgTaxaDeLixo from '@/assets/topic-seeds/taxa-de-lixo.jpg.asset.json';
import imgTaxasDeFiscalizacao from '@/assets/topic-seeds/taxas-de-fiscalizacao.jpg.asset.json';
import imgTaxasDePolicia from '@/assets/topic-seeds/taxas-de-policia.jpg.asset.json';
import imgTaxasJudiciarias from '@/assets/topic-seeds/taxas-judiciarias.jpg.asset.json';
import imgTcfaFiscalizacaoAmbiental from '@/assets/topic-seeds/tcfa-fiscalizacao-ambiental.jpg.asset.json';
import imgTechnologyInTaxServices from '@/assets/topic-seeds/technology-in-tax-services.jpg.asset.json';
import imgTipicidadeTributaria from '@/assets/topic-seeds/tipicidade-tributaria.jpg.asset.json';
import imgTouristTax from '@/assets/topic-seeds/tourist-tax.jpg.asset.json';
import imgTpDocumentation from '@/assets/topic-seeds/tp-documentation.jpg.asset.json';
import imgTransacaoTributaria from '@/assets/topic-seeds/transacao-tributaria.jpg.asset.json';
import imgTransferPricing from '@/assets/topic-seeds/transfer-pricing.jpg.asset.json';
import imgTransicaoFederativa from '@/assets/topic-seeds/transicao-federativa.jpg.asset.json';
import imgTratamentoFavorecidoZfm from '@/assets/topic-seeds/tratamento-favorecido-zfm.jpg.asset.json';
import imgTravaDaCargaTributaria from '@/assets/topic-seeds/trava-da-carga-tributaria.jpg.asset.json';
import imgTributacaoDeCriptoativos from '@/assets/topic-seeds/tributacao-de-criptoativos.jpg.asset.json';
import imgTributacaoDeDividendos from '@/assets/topic-seeds/tributacao-de-dividendos.jpg.asset.json';
import imgTributacaoDeOffshores from '@/assets/topic-seeds/tributacao-de-offshores.jpg.asset.json';
import imgTrust from '@/assets/topic-seeds/trust.jpg.asset.json';
import imgUniformidadeGeografica from '@/assets/topic-seeds/uniformidade-geografica.jpg.asset.json';
import imgVat from '@/assets/topic-seeds/vat.jpg.asset.json';
import imgVedacaoAsIsencoesHeteronomas from '@/assets/topic-seeds/vedacao-as-isencoes-heteronomas.jpg.asset.json';
import imgVoluntaryDisclosure from '@/assets/topic-seeds/voluntary-disclosure.jpg.asset.json';
import imgWealthTax from '@/assets/topic-seeds/wealth-tax.jpg.asset.json';
import imgWithholdingTax from '@/assets/topic-seeds/withholding-tax.jpg.asset.json';

export const TOPIC_SEED_IMAGES: Readonly<Record<string, string>> = {
  '1031-exchange': img1031Exchange.url,
  'afrmm-marinha-mercante': imgAfrmmMarinhaMercante.url,
  'aliquota-de-referencia': imgAliquotaDeReferencia.url,
  'antecipacao-de-come-cotas': imgAntecipacaoDeComeCotas.url,
  'anti-money-laundering-aml': imgAntiMoneyLaunderingAml.url,
  'artificial-intelligence-in-law': imgArtificialIntelligenceInLaw.url,
  'auditor-independence': imgAuditorIndependence.url,
  'behavioral-taxation': imgBehavioralTaxation.url,
  'beneficial-ownership': imgBeneficialOwnership.url,
  'beps': imgBeps.url,
  'capacidade-contributiva': imgCapacidadeContributiva.url,
  'capital-gains-tax': imgCapitalGainsTax.url,
  'carbon-credits-taxation': imgCarbonCreditsTaxation.url,
  'carne-leao-web': imgCarneLeaoWeb.url,
  'cashback-tributario': imgCashbackTributario.url,
  'cbs': imgCbs.url,
  'cesta-basica-nacional': imgCestaBasicaNacional.url,
  'cfc-rules': imgCfcRules.url,
  'cide-combustiveis': imgCideCombustiveis.url,
  'cide-remessas': imgCideRemessas.url,
  'citizenship-by-investment': imgCitizenshipByInvestment.url,
  'civil-procedure': imgCivilProcedure.url,
  'cofins': imgCofins.url,
  'comite-gestor-do-ibs': imgComiteGestorDoIbs.url,
  'confaz': imgConfaz.url,
  'constitutional-jurisdiction': imgConstitutionalJurisdiction.url,
  'constitutional-tax-law': imgConstitutionalTaxLaw.url,
  'contribuicao-de-melhoria': imgContribuicaoDeMelhoria.url,
  'contribuicao-previdenciaria-patronal': imgContribuicaoPrevidenciariaPatronal.url,
  'contribuicao-sindical-assistencial': imgContribuicaoSindicalAssistencial.url,
  'corporate-governance': imgCorporateGovernance.url,
  'corporate-reorganization': imgCorporateReorganization.url,
  'corporate-tax': imgCorporateTax.url,
  'cosip-iluminacao-publica': imgCosipIluminacaoPublica.url,
  'credito-financeiro': imgCreditoFinanceiro.url,
  'criminal-procedure': imgCriminalProcedure.url,
  'critical-tax-theory': imgCriticalTaxTheory.url,
  'crs': imgCrs.url,
  'cryptocurrency-tax': imgCryptocurrencyTax.url,
  'csll': imgCsll.url,
  'debt-enforcement': imgDebtEnforcement.url,
  'declaracao-pre-preenchida': imgDeclaracaoPrePreenchida.url,
  'deducoes-de-educacao': imgDeducoesDeEducacao.url,
  'deducoes-de-saude': imgDeducoesDeSaude.url,
  'deposit-contract-law': imgDepositContractLaw.url,
  'difal-interestadual': imgDifalInterestadual.url,
  'digital-services-tax': imgDigitalServicesTax.url,
  'digitalization-of-legal-processes': imgDigitalizationOfLegalProcesses.url,
  'drawback-aduaneiro': imgDrawbackAduaneiro.url,
  'economic-stability': imgEconomicStability.url,
  'emprestimo-compulsorio': imgEmprestimoCompulsorio.url,
  'energy-tariffs': imgEnergyTariffs.url,
  'estate-planning': imgEstatePlanning.url,
  'estate-tax': imgEstateTax.url,
  'ex-tarifario': imgExTarifario.url,
  'exclusao-do-credito-tributario': imgExclusaoDoCreditoTributario.url,
  'exit-tax': imgExitTax.url,
  'extincao-do-credito-tributario': imgExtincaoDoCreditoTributario.url,
  'fatca': imgFatca.url,
  'fbar': imgFbar.url,
  'fdii': imgFdii.url,
  'fgts-digital': imgFgtsDigital.url,
  'financial-regulatory-compliance': imgFinancialRegulatoryCompliance.url,
  'financial-system-regulation': imgFinancialSystemRegulation.url,
  'financial-transaction-tax': imgFinancialTransactionTax.url,
  'fiscal-policy': imgFiscalPolicy.url,
  'fiscal-transparency': imgFiscalTransparency.url,
  'foreign-tax-credit': imgForeignTaxCredit.url,
  'form-3520': imgForm3520.url,
  'form-5471': imgForm5471.url,
  'form-8865': imgForm8865.url,
  'foundation': imgFoundation.url,
  'fundo-de-desenvolvimento-regional': imgFundoDeDesenvolvimentoRegional.url,
  'fundos-exclusivos': imgFundosExclusivos.url,
  'ganho-de-capital': imgGanhoDeCapital.url,
  'gift-tax': imgGiftTax.url,
  'gilti': imgGilti.url,
  'government-spending-programs': imgGovernmentSpendingPrograms.url,
  'holding-company': imgHoldingCompany.url,
  'ibs': imgIbs.url,
  'icms': imgIcms.url,
  'ie-imposto-de-exportacao': imgIeImpostoDeExportacao.url,
  'ii-imposto-de-importacao': imgIiImpostoDeImportacao.url,
  'imposto-do-pecado': imgImpostoDoPecado.url,
  'imposto-seletivo': imgImpostoSeletivo.url,
  'in-dubio-pro-reo-fiscal': imgInDubioProReoFiscal.url,
  'income-tax': imgIncomeTax.url,
  'interdisciplinary-tax-law': imgInterdisciplinaryTaxLaw.url,
  'international-accounting-standards': imgInternationalAccountingStandards.url,
  'international-tax-compliance': imgInternationalTaxCompliance.url,
  'international-tax-policy': imgInternationalTaxPolicy.url,
  'interpretacao-benigna': imgInterpretacaoBenigna.url,
  'iof-cambio-e-credito': imgIofCambioECredito.url,
  'ipi': imgIpi.url,
  'iptu': imgIptu.url,
  'iptu-progressivo': imgIptuProgressivo.url,
  'ipva-aeronaves-e-embarcacoes': imgIpvaAeronavesEEmbarcacoes.url,
  'irpf': imgIrpf.url,
  'irpj': imgIrpj.url,
  'isencao-por-doenca-grave': imgIsencaoPorDoencaGrave.url,
  'iss': imgIss.url,
  'itbi': imgItbi.url,
  'itbi-momento-de-incidencia': imgItbiMomentoDeIncidencia.url,
  'itcmd': imgItcmd.url,
  'itcmd-progressivo': imgItcmdProgressivo.url,
  'itr-propriedade-rural': imgItrPropriedadeRural.url,
  'iva-dual': imgIvaDual.url,
  'judicial-appeals': imgJudicialAppeals.url,
  'judicial-integrity': imgJudicialIntegrity.url,
  'judicial-penalties': imgJudicialPenalties.url,
  'judicial-review': imgJudicialReview.url,
  'juros-sobre-capital-proprio': imgJurosSobreCapitalProprio.url,
  'lancamento-de-oficio': imgLancamentoDeOficio.url,
  'lancamento-por-homologacao': imgLancamentoPorHomologacao.url,
  'laudemio-e-foro': imgLaudemioEForo.url,
  'legal-procedure-reform': imgLegalProcedureReform.url,
  'legislative-process': imgLegislativeProcess.url,
  'llc-taxation': imgLlcTaxation.url,
  'lucro-arbitrado': imgLucroArbitrado.url,
  'lucro-presumido': imgLucroPresumido.url,
  'lucro-real': imgLucroReal.url,
  'malha-fina-digital': imgMalhaFinaDigital.url,
  'monofasia-tributaria': imgMonofasiaTributaria.url,
  'nao-cumulatividade-plena': imgNaoCumulatividadePlena.url,
  'nfe': imgNfe.url,
  'opportunity-zone': imgOpportunityZone.url,
  'outsourcing-of-professional-services': imgOutsourcingOfProfessionalServices.url,
  'partnership': imgPartnership.url,
  'payroll-tax': imgPayrollTax.url,
  'permanent-establishment': imgPermanentEstablishment.url,
  'pfic': imgPfic.url,
  'pillar-two': imgPillarTwo.url,
  'pis': imgPis.url,
  'praticabilidade-tributaria': imgPraticabilidadeTributaria.url,
  'pricing-of-tax-services': imgPricingOfTaxServices.url,
  'principio-da-anterioridade': imgPrincipioDaAnterioridade.url,
  'principio-da-irretroatividade': imgPrincipioDaIrretroatividade.url,
  'principio-da-isonomia': imgPrincipioDaIsonomia.url,
  'principio-da-legalidade': imgPrincipioDaLegalidade.url,
  'principio-da-seletividade': imgPrincipioDaSeletividade.url,
  'principio-do-destino': imgPrincipioDoDestino.url,
  'principio-do-nao-confisco': imgPrincipioDoNaoConfisco.url,
  'private-client': imgPrivateClient.url,
  'procedural-tax-law': imgProceduralTaxLaw.url,
  'professional-ethics-in-taxation': imgProfessionalEthicsInTaxation.url,
  'professional-regulation': imgProfessionalRegulation.url,
  'progressive-taxation': imgProgressiveTaxation.url,
  'property-tax': imgPropertyTax.url,
  'public-finance-management': imgPublicFinanceManagement.url,
  'public-service-administration': imgPublicServiceAdministration.url,
  'public-service-fees': imgPublicServiceFees.url,
  'rat-risco-ambiental-trabalho': imgRatRiscoAmbientalTrabalho.url,
  'rd-tax-credits': imgRdTaxCredits.url,
  'receita-federal': imgReceitaFederal.url,
  'reforma-tributaria': imgReformaTributaria.url,
  'regimes-diferenciados': imgRegimesDiferenciados.url,
  'remessa-conforme': imgRemessaConforme.url,
  'residencia-fiscal': imgResidenciaFiscal.url,
  's-corporation': imgSCorporation.url,
  'salario-educacao': imgSalarioEducacao.url,
  'section-962': imgSection962.url,
  'seguranca-juridica': imgSegurancaJuridica.url,
  'simples-nacional': imgSimplesNacional.url,
  'siscomex': imgSiscomex.url,
  'sistema-s': imgSistemaS.url,
  'social-security-benefits': imgSocialSecurityBenefits.url,
  'sped': imgSped.url,
  'split-payment': imgSplitPayment.url,
  'state-tax': imgStateTax.url,
  'statute-of-limitations-prescription': imgStatuteOfLimitationsPrescription.url,
  'subpart-f': imgSubpartF.url,
  'substituicao-tributaria': imgSubstituicaoTributaria.url,
  'suspensao-da-exigibilidade': imgSuspensaoDaExigibilidade.url,
  'tax-administrative-procedures': imgTaxAdministrativeProcedures.url,
  'tax-appeals': imgTaxAppeals.url,
  'tax-audit': imgTaxAudit.url,
  'tax-career-development': imgTaxCareerDevelopment.url,
  'tax-classification': imgTaxClassification.url,
  'tax-debt-resolution': imgTaxDebtResolution.url,
  'tax-education': imgTaxEducation.url,
  'tax-immunity': imgTaxImmunity.url,
  'tax-incentives': imgTaxIncentives.url,
  'tax-law-fundamentals': imgTaxLawFundamentals.url,
  'tax-litigation': imgTaxLitigation.url,
  'tax-optimization': imgTaxOptimization.url,
  'tax-policy-challenges': imgTaxPolicyChallenges.url,
  'tax-residency': imgTaxResidency.url,
  'tax-system-complexity': imgTaxSystemComplexity.url,
  'tax-treaties': imgTaxTreaties.url,
  'tax-valuation': imgTaxValuation.url,
  'taxa-de-incendio': imgTaxaDeIncendio.url,
  'taxa-de-lixo': imgTaxaDeLixo.url,
  'taxas-de-fiscalizacao': imgTaxasDeFiscalizacao.url,
  'taxas-de-policia': imgTaxasDePolicia.url,
  'taxas-judiciarias': imgTaxasJudiciarias.url,
  'tcfa-fiscalizacao-ambiental': imgTcfaFiscalizacaoAmbiental.url,
  'technology-in-tax-services': imgTechnologyInTaxServices.url,
  'tipicidade-tributaria': imgTipicidadeTributaria.url,
  'tourist-tax': imgTouristTax.url,
  'tp-documentation': imgTpDocumentation.url,
  'transacao-tributaria': imgTransacaoTributaria.url,
  'transfer-pricing': imgTransferPricing.url,
  'transicao-federativa': imgTransicaoFederativa.url,
  'tratamento-favorecido-zfm': imgTratamentoFavorecidoZfm.url,
  'trava-da-carga-tributaria': imgTravaDaCargaTributaria.url,
  'tributacao-de-criptoativos': imgTributacaoDeCriptoativos.url,
  'tributacao-de-dividendos': imgTributacaoDeDividendos.url,
  'tributacao-de-offshores': imgTributacaoDeOffshores.url,
  'trust': imgTrust.url,
  'uniformidade-geografica': imgUniformidadeGeografica.url,
  'vat': imgVat.url,
  'vedacao-as-isencoes-heteronomas': imgVedacaoAsIsencoesHeteronomas.url,
  'voluntary-disclosure': imgVoluntaryDisclosure.url,
  'wealth-tax': imgWealthTax.url,
  'withholding-tax': imgWithholdingTax.url,
};
